import { Flex, Typography } from '@banhala/ui-kit';
import React, { useMemo } from 'react';
import { formatNumber } from 'shared/src/utils';

export const LabelCount: React.FC<{
  label: string;
  count: number;
  isPercent?: boolean;
}> = props => {
  const label = useMemo(() => {
    if (props.isPercent) {
      return `${Math.floor(props.count)}%`;
    }
    const values = formatNumber(props.count);
    return `${values.value}${values.label}`;
    // return numToKorean(calcCount(), 'float');
  }, [props.count, props.isPercent]);
  return (
    <Flex.Row gap={4}>
      <Typography type={'body3'} color={'content_secondary'}>
        {props.label}
      </Typography>
      <Typography type={'subtitle3'} color={'content_primary'}>
        {label}
      </Typography>
    </Flex.Row>
  );
};
